import { Component, inject, signal} from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgIf, formatDate, DatePipe, DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { FieldErrorDisplayComponent } from '../../../shared/components/field-error-display/field-error-display.component';
import { ShareDataService } from '../../../shared/utils/share-data.service';
import { CommanService } from '../../../shared/utils/comman.service';
import { Constants } from '../../../shared/utils/constants';
import { NotificationService } from '../../../shared/utils/notification.service';
import { DiliveryService } from '../../../services/cng-sails/delivery/dilivery.service';
import { SafePipe } from '../../../shared/pipes/safe.pipe';
import { NgLabelTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { DropDownService } from '../../../services/cng-sails/drop-down.service';
import { MastersService } from '../../../services/cng-sails/masters/masters.service';
import moment from 'moment';
import { IndianTimeMomentPipe } from '../../../shared/pipes/indian-moment.pipe';
import { IndianDatePipe } from '../../../shared/pipes/indian-date.pipe';
import { IndianDateMomentPipe } from '../../../shared/pipes/date-convert.pipe';
import { SubtractPipe } from '../../../shared/pipes/subtract.pipe';
import { TimeDiffPipe } from '../../../shared/pipes/time-diff.pipe';

@Component({
  selector: 'app-deliverychallan',
  standalone: true,
  imports: [ReactiveFormsModule, FieldErrorDisplayComponent,NgSelectComponent, NgIf, DatePipe, DecimalPipe, SafePipe,IndianDatePipe,IndianTimeMomentPipe, SubtractPipe, TimeDiffPipe],
  templateUrl: './deliverychallan.component.html',
  styleUrl: './deliverychallan.component.scss'
})
export class DeliverychallanComponent {
  deliveryDtaSignal = signal<{} | null>(null);
  shareDataService = inject(ShareDataService);
  commonService = inject(CommanService);
  notificationService = inject(NotificationService);
  diliveryService = inject(DiliveryService)
  fb = inject(FormBuilder);
  subscription: Subscription;
  public constants = Constants;
  deliveryChallanSearch: FormGroup;
  deliveryChallan: FormGroup;
  deliveryChallanData:any[]= [];
  challanSearchData:any[]= [];
  selectedOption:any;
  challanObj:any;
  pdfSrc: string = '';
  isShowHide:boolean = false;
  PlantCodeDropDown: any[] = []; // Consider a more specific type
  GA: any[] = [];          // Consider a more specific type
  gaName: string = '';
  dropDownService = inject(DropDownService);
  mastersService = inject(MastersService);
  vehicleMasterList: any[] = [];
  sortedVehicleMasterList: any[] = [];
  fillData: any
  maxStartDateTime: any;
  minStartDateTime: any;
  momentType:any;
  constructor() {
    this.shareDataService.setData("DELIVERY CHALLAN");
    this.subscription = new Subscription();
    this.deliveryChallanSearch = this.fb.group({
      ga_code:[ null],
      source_station_type: ["MS"],
      source_plant_code:[null],
      sale_date:[null],
      vehicle_number:['']
    });

    this.deliveryChallan = this.fb.group({
      sale_date: [''],
      ga_code:[null],
      ga_name:[null],
      source_station_type: ["MS"],
      source_plant_code:[null],
      sequence_no: ['']
    });
  }
  ngOnInit() {
    this.getGADropDown();

  };
  private getGADropDown() {
    this.dropDownService.getGA().subscribe(item => {
      let response: any = item; // TODO: Type this better
      if (response.code == 200) {
        this.GA = response.data; // Assuming `item.data` is the array you need
      }
    });
  }
  /*
   *   function name: isFieldValid()
   *   functionality: To check if all the form fields are valid  
   *   parameters : field
   */
  public isFieldValid(field: string) {
    let result = this.commonService.isFormFieldValid(field, this.deliveryChallan);
    return result;
  }

  /*
*   function name: displayFieldCss()
*   functionality: To display error class if validation fails  
*   parameters : field
*/
  public displayFieldCss(field: string) {
    let result = this.commonService.displayFieldCss(field, this.deliveryChallan);
    return result;
  }

  
  onCheckboxChange(option: any) {
    this.challanObj = option;
    this.deliveryChallan.patchValue({
      source_plant_code:this.challanObj.source_plant_code,
      sequence_no: this.challanObj.sequence_no,
      sale_date: this.deliveryChallanSearch.value.sale_date,

    })
    this.selectedOption = this.selectedOption === option?.sequence_no ? '' : option?.sequence_no;
  }
  public deliveryChalanSearch() {
    if (this.deliveryChallanSearch.valid) {
      let formData = this.deliveryChallanSearch.value;
      this.subscription = this.diliveryService.deliverySearch(formData).subscribe((data: any) => {
        let response: any = data;
        if (response.code == 200) {
          this.challanSearchData = response.data;
        } else {
          this.notificationService.notification('danger', response.message, "", null);
        }
      },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        });
    } else {
      this.commonService.validateAllFormFields(this.deliveryChallanSearch,"Validation Error");
    }
  };

  public deliveryChalanSubmit() {
    if (this.deliveryChallan.valid) {
      let formData = this.deliveryChallan.value;
      this.subscription = this.diliveryService.deliverySubmit(formData).subscribe((data: any) => {
        let response: any = data;
        if (response.code == 200) {
          this.deliveryChallanData = response.data;
          this.challanObj = this.deliveryChallanData[0];
          this.momentType = this.deliveryChallanData[0]?.movement_type
          this.isShowHide = false;
        } else {
          this.notificationService.notification('danger', response.message, "", null);
        }
      },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        });
    } else {
      this.commonService.validateAllFormFields(this.deliveryChallan,"Validation Error");
    }
  };

  generatePDF() {
    this.isShowHide = true;
    setTimeout(() => {
      const data = document.getElementById('pdfContent');
      if (data) {
        html2canvas(data, { scale: 1 })
          .then((canvas) => {
            const imgQuality = 0.5;
            const imgData = canvas.toDataURL('image/jpeg', imgQuality);
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const ratio = canvasWidth / canvasHeight;
            let imgWidth = pdfWidth;
            let imgHeight = imgWidth / ratio;
            if (imgHeight > pdfHeight) {
              imgHeight = pdfHeight;
              imgWidth = imgHeight * ratio;
            }
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight, undefined, 'FAST');
  
            pdf.save('deliveryChallan.pdf');
            this.isShowHide = false;
          });
      } else {
        console.error("Element with ID 'pdfContent' not found.");
        this.isShowHide = false;
      }
    }, 100);
  }
  public getPlantCode(data: any) { // TODO: Type `data` more specifically
    this.gaName = data.name_of_ga;
    this.deliveryChallanSearch.get('source_plant_code')?.reset();
    this.deliveryChallanSearch.get('vehicle_number')?.reset();
    this.getvehicleMasterListByGA(data.ga_code);
    this.dropDownService.getPlantCodeByGaName({ ga_code: data.ga_code }).subscribe((item: { data: any; }) => {
      let response: any = item; // TODO: Type this better
      if (response.code == 200) {
        this.PlantCodeDropDown = (item?.data || [])
          .filter((item: any) => item?.station_type === 'MS')
          .sort((a: any, b: any) => a?.plant_code.localeCompare(b?.plant_code));
          const renamedData = this.PlantCodeDropDown?.map((item: { [x: string]: any; plant_code: any; }) => {
            const { plant_code, ...rest } = item;
            return {
              ...rest, 
              source_plant_code: plant_code
            };
          });
          this.PlantCodeDropDown =renamedData;
          console.log(renamedData);
      }
    });
  }
  public getvehicleMasterListByGA(ga_code:any) {
    this.subscription = this.mastersService.getVehicleMasterDropDownBYGA(ga_code).subscribe((data) => {
      let response: any = data;
      if (response.code == 200) {
        this.vehicleMasterList = response.data;
        //this.notificationService.notification('success', response.message, "", null);
        this.sortedVehicleMasterList = [...this.vehicleMasterList].sort((a: any, b: any) =>
          a.vehicle_no.localeCompare(b.vehicle_no)
        );
      } else {
        this.notificationService.notification('danger', response.message, "", null);
      }
    },
      err => {
        this.notificationService.notification('danger', err.message, '', null);
      });
  }
  previewPDF() {
    this.isShowHide = true;
    setTimeout(() => {
    const data = document.getElementById('pdfContent'); // The content to capture
    if (data) {
      html2canvas(data).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4'); 
        const imgWidth = 210; // Width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);     
        const pdfBlob = pdf.output('blob');
        const pdfURL = URL.createObjectURL(pdfBlob);
        this.pdfSrc = pdfURL;
        //window.open(pdfURL);
        this.isShowHide = false;
      });
    }
  }, 100);
  }
  public getReportingTime(data: any) {
    if (!data.vehicle_no) {
      return;
    }
      this.mastersService.getReportingTime(data.vehicle_no).subscribe(
      (data) => {
        const response: any = data;
        this.fillData = response;
        if (response.code === 200 && response.data?.filling_end_time) {
        const lastFillingEndTime = new Date(response.data.filling_end_time);
        const currentTime = new Date();
        this.minStartDateTime = this.formatDateTimeForPatch2(lastFillingEndTime);
        this.maxStartDateTime = this.formatDateTimeForPatch2(currentTime);
        this.deliveryChallanSearch.controls['vehicle_number'].setValidators([
          this.dateTimeRangeValidator(),
        ]);
        this.deliveryChallanSearch.controls['vehicle_number'].updateValueAndValidity();
        //this.dateTimeRangeValidator(this.minStartDateTime, this.maxStartDateTime)
        }else{
          this.notificationService.notification('warning', response.message, "", null);
        }
      },
    );
  }
    dateTimeRangeValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const minDateTime = new Date(this.minStartDateTime).getTime();
        const maxDateTime = new Date(this.maxStartDateTime).getTime();
    
        if (!control.value) {
          return { required: true, message: 'Date and time are required' };
        }
    
        const selectedDateTime = new Date(control.value).getTime();
    
        if (selectedDateTime < minDateTime) {
          return { tooEarly: true, message: `Time should not be before ${this.minStartDateTime}` };
        }
        if (selectedDateTime > maxDateTime) {
          return { tooLate: true, message: `Time should not exceed ${this.maxStartDateTime}` };
        }
    
        return null;
      };
    }
  onVehicleNumberChange(vehicle_number: any) {
    this.getReportingTime(vehicle_number);
  }
    private formatDateTimeForPatch2(date: Date): string {
      return moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
}
  /**
   * on destroy
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}


